import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type Member = {
  _id: string;
  email?: string;
};

export interface DepartmentDetail {
  workingHours: any;
  supervisor: any;
  _id: string;
  name: string;
  description?: string;
  handbook?: string;
  status: "active" | "inactive" | string;
  organization?: string;
  members: Member[];
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type DepartmentResponse = {
  success: boolean;
  data: DepartmentDetail;
  message?: string;
};

const fetchDepartment = async (id: string): Promise<DepartmentResponse> => {
  const { data } = await customAxios.get<DepartmentResponse>(
    `/departments/${id}`
  );
  return data;
};

export const useGetDepartmentById = (id?: string | null) =>
  useQuery<DepartmentResponse, AxiosError>(
    ["department", id],
    () => {
      if (!id) throw new Error("No department id provided");
      return fetchDepartment(id);
    },
    {
      enabled: !!id,
      onError: (error) =>
        showNotification({
          title: "Error Loading Department",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load department",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
